import React, { useEffect } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  Box,
  Button,
  FormControl,
  Skeleton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Typography,
  Grid2 as Grid,
  Card,
  CardContent
} from '@mui/material';
import {
  List as ListIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import '../../styles/components/Sidebar.scss';
import logoWhite from '../../assets/logos/logo-white.png'
import { useLoader } from '../../context/LoaderContext.js';


function SignInComponent() {
  const { hideLoader } = useLoader();
  const routes = [
    { path: '/', name: 'Administración', type: 'title', icon: <ListIcon /> },
    { type: 'loading' },
    { type: 'loading' },
    { type: 'loading' },
    { path: '/', name: 'Configuración', type: 'title', icon: <ListIcon /> },
    { type: 'loading' },
  ];

  useEffect(() => {
    hideLoader()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <Drawer
        variant="permanent"
        className="sidebar"
      >
        <Box className="logo-container">
          <Link to="/" style={{ textDecoration: "none" }}>
            <img src={logoWhite} alt="Logo" />
          </Link>
        </Box>
        <div className="separator" />
        <Divider />
        <FormControl variant="standard" sx={{ margin: '16px' }}>
          <Skeleton
            variant="text"
            width={"100%"}
            height={70}
            sx={{
              bgcolor: "rgba(0, 0, 0, .17)",
              "&::after": {
                background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)"
              }
            }}
            animation="wave"
          />
        </FormControl>
        <List>
          {Array.isArray(routes) && routes.map((r, index) => (r.type === 'title' ?
            <ListItem>
              <ListItemText primary={r.name} sx={{ fontWeight: 'bold', color: '#ffffff' }} />
            </ListItem>
            : (
              <ListItem
                key={index}
                onClick={r.action}
                sx={{
                  bgcolor: 'transparent',
                }}
              >
                <Skeleton
                  variant="text"
                  width={"100%"}
                  height={70}
                  sx={{
                    bgcolor: "rgba(0, 0, 0, .17)",
                    "&::after": {
                      background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)"
                    }
                  }}
                  animation="wave"
                />
              </ListItem>
            )
          ))}
        </List>

        <div className="button-container">
          <Button
            variant="contained"
            color="primary"
            fullWidth
            href="#"
            sx={{ background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)' }}
          >
            Hablar con nuestros expertos
          </Button>
        </div>
      </Drawer>
      <div style={{
        marginLeft: "250px",
        padding: "50px"
      }}>
        <Skeleton
          variant="text"
          width={"40%"}
          sx={{
            bgcolor: "rgba(0, 0, 0, .17)",
            "&::after": {
              background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)"
            }
          }}
          animation="wave"
          style={{
            marginBottom: 20
          }}
        />
        <Grid container spacing={2}>
          <Grid size={4}>
            <Card sx={{ minWidth: 275 }}>
              <CardContent>
                <Skeleton
                  variant="text"
                  width={"100%"}
                  sx={{
                    bgcolor: "rgba(0, 0, 0, .17)",
                    "&::after": {
                      background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)"
                    }
                  }}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={"100%"}
                  height={200}
                  sx={{
                    bgcolor: "rgba(0, 0, 0, .17)",
                    "&::after": {
                      background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)"
                    }
                  }}
                  animation="wave"
                />
              </CardContent>
            </Card>

          </Grid>
          <Grid size={4}>
            <Card sx={{ minWidth: 275 }}>
              <CardContent>
                <Skeleton
                  variant="text"
                  width={"100%"}
                  sx={{
                    bgcolor: "rgba(0, 0, 0, .17)",
                    "&::after": {
                      background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)"
                    }
                  }}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={"100%"}
                  height={200}
                  sx={{
                    bgcolor: "rgba(0, 0, 0, .17)",
                    "&::after": {
                      background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)"
                    }
                  }}
                  animation="wave"
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid size={4}>
            <Card sx={{ minWidth: 275 }}>
              <CardContent>
                <Skeleton
                  variant="text"
                  width={"100%"}
                  sx={{
                    bgcolor: "rgba(0, 0, 0, .17)",
                    "&::after": {
                      background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)"
                    }
                  }}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={"100%"}
                  height={200}
                  sx={{
                    bgcolor: "rgba(0, 0, 0, .17)",
                    "&::after": {
                      background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)"
                    }
                  }}
                  animation="wave"
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid size={12}>
            <Card>
              <CardContent>
                <Skeleton
                  variant="text"
                  width={"100%"}
                  sx={{
                    bgcolor: "rgba(0, 0, 0, .17)",
                    "&::after": {
                      background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)"
                    }
                  }}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={"100%"}
                  height={570}
                  sx={{
                    bgcolor: "rgba(0, 0, 0, .17)",
                    "&::after": {
                      background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)"
                    }
                  }}
                  animation="wave"
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
      <Dialog
        open={true}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
        sx={{ '& .MuiDialog-container': { alignItems: 'flex-start', marginTop: '25vh' } }}

        slotProps={{
          paper: {
            sx: { borderRadius: '16px' }
          }
        }}
      >
        <DialogTitle id="alert-dialog-title" height={70}>
          <div style={{
            backgroundImage: "linear-gradient(195deg, #42424a 0%, var(--bs-tiga-deep-blue) 100%)",
            borderRadius: "12px",
            position: "absolute",
            height: "64px"
          }}>
            <img src={logoWhite} alt="Logo" style={{
              height: "45px",
              padding: "10px"
            }} />
          </div>
        </DialogTitle>
        <DialogContent >
          <DialogContentText id="alert-dialog-description" textAlign={"right"}>
            <Typography variant="h5" gutterBottom color='rgb(52, 71, 103);'>
              Firma centralizada
            </Typography>
            <Typography variant="caption" gutterBottom sx={{ display: 'block' }}>
              Autoatención
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description" textAlign={"right"}>
            Inicie sesión con su cuenta de Google para continuar


          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>

  );
}

export default SignInComponent;
